export default "__VITE_ASSET__4PUwpG6g__"